import { styled, SxProps } from '@mui/material/styles'
import { FormControl, Select, MenuItem, Typography, OutlinedInput } from '@mui/material'
import './style.css'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { colors } from '../../constants/colors'
import HelperText from '../input/helperText';
import React from 'react';

export type BasicSelectProps = {
    labelId: string
    selectId: string
    label?: string
    value?: any
    onchange?: (value: any) => void;
    onChange?: (e: any) => void;
    renderValue?: (value: any) => void
    options: any
    fullWidth?: boolean
    multiple?: boolean
    required?: boolean
    formControlClass?: any
    register?: any
    name?: any
    style?: React.CSSProperties
    helperText?: string
    formControlStyle?: SxProps;
    disabled?: boolean
    classesOption?: string
    inputHeight?: number
    heading?: string
    headingAlign?: 'center' | 'left' | 'right',
    headingNormal?: boolean
    placeholder?: string;
    onInvalid?: (value: any) => void;
    markRequired?: string;
    onCheckBox?: (event: any) => void;
    checkBoxValue?: string[] | number[];
}

// const PlaceholderCustom = (text: string | undefined) => (
//     <Typography sx={{ color: "#DDE1EB" }}>
//         {text}
//     </Typography>
// )
const PlaceholderCustom = (text: string | undefined) => (
    <Typography sx={{ color: "#DDE1EB" }}>
        {text}
    </Typography>
)

const StyledFilterSelect = styled(Select)<{ inputHeight?: number }>(({ theme, inputHeight }) => ({
    height: inputHeight || '43px',
    background: colors.white,
    '& .MuiSelect-select': {
        padding: '0 1rem'
    },
    '& .MuiInputBase-root': {
        height: '100%',
        borderRadius: 8,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: 8,
        top: '-5px !important',
        borderColor: colors.borderInput,
        legend: {
            width: 0
        }
    },
    '& .MuiSvgIcon-root': {
        color: colors.black
    },
    '& fieldset, &.Mui-focused fieldset': {
        borderColor: `${colors.black_12} !important`
    },
    '& svg': {
        position: 'absolute',
        fontSize: '16px',
        right: '0.625rem'
    },
    '& [aria-expanded="true"] + input + svg': {
        transform: 'rotate(180deg)'
    },
    '&.Mui-disabled': {
        '.MuiOutlinedInput-notchedOutline': {
            backgroundColor: colors.black_12
        },
        '.MuiSelect-select': {
            color: colors.black_60,
            '-webkit-text-fill-color': 'unset'
        }
    },
    '&.Mui-focused': {
        '.MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px !important'
        },
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderWidth: "2px !important",
        borderColor: `${theme.palette.error.main} !important`
    }
}));

const CustomFormControl = styled(FormControl)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        // maxWidth: 285,
        '&.not-max-width': { maxWidth: 9999 }
    }
}))

export default function FilterSelect(props: BasicSelectProps) {
    return (
        <>
            {props.heading &&
                <div className='pb-2 flex gap-1' style={{ textAlign: props.headingAlign || 'left' }}>
                    <Typography variant={props.headingNormal ? 'subtitle1' : 'body1'}>
                        {props.heading}
                    </Typography>
                    {props.required || props.markRequired ? <Typography sx={{ color: "red" }} className='text-rose-600'>*</Typography> : ""}
                </div>
            }
            <CustomFormControl
                error={props.helperText ? true : false}
                className={`${props.formControlClass}`} size="small" margin="none" fullWidth={props.fullWidth !== undefined ? props.fullWidth : true} disabled={props.disabled} sx={{ ...props.formControlStyle }}>
                <StyledFilterSelect
                    inputRef={(input: { focus: () => any }) =>
                        props.helperText && input?.focus()
                    }
                    MenuProps={{
                        classes: { paper: `style-filter-select-search custom-scroll ${props.classesOption} style-select-doctors` },
                        PaperProps: {
                            sx: {
                                '.MuiMenuItem-root': {
                                    '&:hover': {
                                        backgroundColor: `${colors.green_06} !important`,
                                        color: colors.themeMainColor
                                    }
                                },
                            },
                        },
                    }}
                    displayEmpty
                    placeholder={props.placeholder}
                    inputHeight={props.inputHeight}
                    style={{ ...props.style }}
                    {...props.register}
                    name={props.name}
                    labelId={props.labelId}
                    id={props.selectId}
                    value={props.value}
                    // renderValue={props.renderValue}
                    renderValue={props.placeholder && !props.value ? () => PlaceholderCustom(props.placeholder) : props.renderValue}
                    // props.placeholder && !props.value ? () => PlaceholderCustom(props.placeholder) : 
                    label={props.label}
                    onChange={props.onCheckBox ? props.onCheckBox : (props.onchange || props.onChange)}
                    multiple={props.multiple || false}
                    IconComponent={() => <KeyboardArrowDownIcon />}
                    disabled={props.disabled}
                    required={props.required}
                    onInvalid={props.onInvalid}
                    input={<OutlinedInput label="Tag" />}
                >
                    {(props.options?.length > 0) ? (
                        props?.options
                    ) : (
                        <MenuItem
                            value={''}
                            className="pe-none text-center"
                            sx={{
                                '&.text-center': {
                                    justifyContent: 'center !important',
                                    paddingTop: '0 !important',
                                    paddingBottom: '0 !important'
                                }
                            }}>
                            {'ไม่พบข้อมูล'}
                        </MenuItem>
                    )}
                </StyledFilterSelect>
                {props.helperText && (
                    <HelperText label={props.helperText} />
                )}
            </CustomFormControl>
        </>
    )
}
